import { readStored, writeStored } from '../lib/hooks';

/**
 * What a guest's own browser remembers (only if they tick "Remember me"):
 * their contact details, and their bookings at each venue for "Book again"
 * and quick access to the manage link. Nothing here is shared with anyone.
 */
export interface GuestDetails {
  name: string;
  phone: string;
  email: string;
}

export interface RememberedBooking {
  reference: string;
  token: string;
  date: string;
  time: string;
  party_size: number;
  table_ids: string[];
  table_labels: string[];
  venue_name: string;
}

const DETAILS_KEY = 'sb.guest';
const bookingsKey = (slug: string) => `sb.bookings.${slug}`;

export function loadGuest(): GuestDetails | null {
  return readStored<GuestDetails | null>(DETAILS_KEY, null);
}

export function saveGuest(details: GuestDetails | null) {
  writeStored(DETAILS_KEY, details);
}

export function loadBookings(slug: string): RememberedBooking[] {
  return readStored<RememberedBooking[]>(bookingsKey(slug), []);
}

export function rememberBooking(slug: string, booking: RememberedBooking) {
  const list = loadBookings(slug).filter((b) => b.reference !== booking.reference);
  list.unshift(booking);
  writeStored(bookingsKey(slug), list.slice(0, 10));
}

export function forgetEverything(slug: string) {
  writeStored(DETAILS_KEY, null);
  writeStored(bookingsKey(slug), null);
}
